import { GetEvaluationFormDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetEvaluationForm = (id: string | null) => {
  const { loading, data } = useQuery(GetEvaluationFormDocument, {
    variables: { id: id ?? '0' },
    skip: !id,
  })

  return {
    loading,
    evaluationForm: data?.ats.evaluationForm,
  }
}
